module.exports = __webpack_public_path__ + "img/2.cb99d3bb.png";